module.exports = __webpack_public_path__ + "img/ballon.f0540937.png";